import API from "@constants/API";

const BASE_URL = "https://api.dev.daily.co.id/expantion/branch/dashboard/v1/branchs";

export const getBranchAPI = async () => {
  const response = await API.HTTP.get(BASE_URL);
  return response.data;
};
